import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { KeyRound, Loader2, UserPlus } from 'lucide-react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { API } from './api';

const VIDE = { prenom: '', nom: '', email: '', password: '' };

const Compte = ({ c, headers, onReload }) => {
  const [pwd, setPwd] = useState('');
  const patch = async (body, msg) => {
    try { await axios.patch(`${API}/comptabilite/admin/comptes/${c.id}`, body, { headers }); toast.success(msg); setPwd(''); onReload(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Action impossible'); }
  };
  return (
    <li className="flex flex-wrap items-center gap-2 py-2 border-t border-slate-100 text-sm" data-testid={`compte-expert-${c.id}`}>
      <span className="font-medium text-slate-900">{[c.prenom, c.nom].filter(Boolean).join(' ')}</span>
      <span className="text-slate-500">{c.email}</span>
      <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${c.is_active ? 'bg-emerald-100 text-emerald-800' : 'bg-slate-200 text-slate-600'}`}>{c.is_active ? 'Actif' : 'Désactivé'}</span>
      <span className="ml-auto flex items-center gap-1">
        <Input type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} placeholder="Nouveau mot de passe" className="h-8 w-44 text-xs" data-testid={`compte-expert-pwd-${c.id}`} />
        <Button size="sm" variant="outline" disabled={!pwd} onClick={() => patch({ password: pwd }, 'Mot de passe modifié')} data-testid={`compte-expert-pwd-btn-${c.id}`}><KeyRound className="h-3.5 w-3.5" /></Button>
        <Button size="sm" variant="outline" onClick={() => patch({ is_active: !c.is_active }, c.is_active ? 'Compte désactivé' : 'Compte réactivé')} data-testid={`compte-expert-toggle-${c.id}`}>
          {c.is_active ? 'Désactiver' : 'Réactiver'}
        </Button>
      </span>
    </li>
  );
};

export const ComptesExpertComptable = ({ headers }) => {
  const [items, setItems] = useState(null);
  const [form, setForm] = useState(VIDE);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => {
    axios.get(`${API}/comptabilite/admin/comptes`, { headers }).then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [load]);
  const creer = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await axios.post(`${API}/comptabilite/admin/comptes`, form, { headers }); toast.success('Compte expert-comptable créé'); setForm(VIDE); load(); }
    catch (err) { toast.error(err.response?.data?.detail || 'Création impossible'); } finally { setBusy(false); }
  };
  const champ = (k, ph, type = 'text') => (
    <Input type={type} value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} placeholder={ph} className="h-9 text-sm" data-testid={`compte-expert-form-${k}`} required={k !== 'prenom'} />
  );
  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-4 space-y-3" data-testid="comptes-expert-comptable">
      <div>
        <h3 className="font-bold text-slate-900">Comptes expert-comptable</h3>
        <p className="text-xs text-slate-500">Accès en lecture seule aux exports mensuels, reçus et justificatifs. Connexion via la page de connexion membres.</p>
      </div>
      <form onSubmit={creer} className="grid grid-cols-1 md:grid-cols-5 gap-2">
        {champ('prenom', 'Prénom')}{champ('nom', 'Nom')}{champ('email', 'E-mail', 'email')}{champ('password', 'Mot de passe (10+ car.)', 'password')}
        <Button type="submit" disabled={busy} className="h-9 bg-[#0a3d62] hover:bg-[#0c4a75]" data-testid="compte-expert-create-btn">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <><UserPlus className="h-4 w-4 mr-1" /> Créer</>}
        </Button>
      </form>
      {!items ? <Loader2 className="h-5 w-5 animate-spin text-slate-400" /> : items.length === 0
        ? <p className="text-sm text-slate-500" data-testid="comptes-expert-empty">Aucun compte créé.</p>
        : <ul>{items.map((c) => <Compte key={c.id} c={c} headers={headers} onReload={load} />)}</ul>}
    </section>
  );
};
